import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom';

const ServiceList = [
    {
        title: 'Audit Your Life',
        description: 'Clarity & Identity Audit – Discover your life’s direction, personal strengths, and what’s holding you back.',
        price: '6000 BDT'
    },
    {
        title: 'Audit Your Business',
        description: 'Business Structure & Profit Review – Diagnose your business model, offer, team, and systems to unlock growth.',
        price: '15,000 BDT'
    },
    {
        title: 'Audit Your Income',
        description: 'Income Stream & Wealth Mapping – Analyze all income sources, pricing, and create a path to financial freedom.',
        price: '10,000 BDT'
    },
    {
        title: 'Audit Your Life, Business & Income',
        description: 'Comprehensive audit across personal, business, and financial aspects to map out a clear path to success.',
        price: '25,000 BDT'
    },
];

const AuditDetails = ({ textAlign, serviceStyle }) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => {
                // Extract numeric amount (remove 'BDT' and spaces)
                const numericAmount = val.price.replace(/[^\d]/g, '');

                // Build query string
                const query = new URLSearchParams({
                    service: 'Audit',
                    package: val.title,
                    amount: numericAmount,
                }).toString();

                return (
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12 d-flex mb-5" key={i}>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}
                            className="w-100"
                        >
                            <div className={`service ${serviceStyle} ${textAlign} card w-100 h-100 d-flex flex-column justify-content-between p-4`}>
                                <div className="mb-3">
                                    <h5 className="mb-2 icon fs-1" style={{color: "white"}}>{val.title} </h5>
                                    <p
                                        className="description b1 mb-2"
                                        dangerouslySetInnerHTML={{ __html: val.description }}
                                    ></p>
                                </div>

                                <div>
                                    <h3 className="mb-2">{val.price}</h3>
                                    <Link
                                        to={`/order?${query}`}
                                        className="w-100 btn btn-default d-block text-center"
                                    >
                                        Purchase
                                    </Link>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                );
            })}
        </div>
    );
};

export default AuditDetails;
